import { useTheme } from '@mui/material/styles';
import { HelpOutlineOutlined } from '@mui/icons-material';

import DetailsList from '../../../../../../common/details-list';
import commonLocales from '../../../../../../../constants/locales';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationUnknown } from './interfaces';

interface Props {
  operation: OperationUnknown;
}

const UnknownOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, amount, acquirerMsisdn, operator } = operation;

  const error =
    details.errorCode && details.errorMessage
      ? { errorCode: details.errorCode, errorMessage: details.errorMessage }
      : undefined;

  return (
    <DetailsFactory
      header={{
        icon: { component: HelpOutlineOutlined, color: theme.palette.grey['700'] },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      error={error}
      operationContent={
        <DetailsList
          items={[
            { label: commonLocales.operation.label.amount, value: formatToAmount(amount.value) },
            { label: commonLocales.operation.label.externalTransactionId, value: details.externalTransactionId },
            {
              label: commonLocales.operation.label.receiver,
              value: detailsValueFormatter(acquirerMsisdn)
            },
            { label: commonLocales.operation.label.referenceId, value: details.referenceId },
            { label: commonLocales.operation.label.operatorName, value: detailsValueFormatter(operator) }
          ]}
        />
      }
    />
  );
};

export default UnknownOperation;
